import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import Dropdown from 'Components/Atoms/Dropdown/Dropdown';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import Loader from 'Components/Atoms/Loader/Loader';
import GlobalSearch from 'Components/Organisms/GlobalSearch/GlobalSearch';
import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccessTokenFromLocal } from 'Services/helpers';
import styles from 'Components/Organisms/PageHeader/PageHeader.module.sass';

const DropdownItem = React.lazy(() => import('Components/Atoms/Dropdown/DropdownItem/DropdownItem'));
const EntityCreateFlow = React.lazy(() => import('Components/Organisms/Entity/EntityCreateFlow/EntityCreateFlow'));

const PageHeader = ({
    children,
    breadcrumbs, padding, position
}: Props) => {
    const navigate = useNavigate();

    return <div
        className={`
            ${styles['header']}
            ${styles['header__padding--'+(padding||'normal')]}
            ${styles['header__position--'+(position||'static')]}
        `}
    >
        <div className={`${styles['header__topbar']}`}>
            {
                breadcrumbs &&
                <div className={styles['header__topbar-breadcrumbs']}>
                    { breadcrumbs }
                </div>
            }
            <div className={styles['header__topbar-search']}>
                {
                    process.env.REACT_APP_ENVIRONMENT === 'dev'&&
                    <Button
                        variant='transparent'
                        color='primary'
                        size='medium'
                        onClick={() => navigator.clipboard.writeText(getAccessTokenFromLocal())}>
                        Copy API Key
                    </Button>
                }
                <Dropdown
                    trigger={
                        <Button
                            variant='solid'
                            color='primary'
                            size='medium'
                            iconBefore={<FontAwesomeIcon icon={faPlus} />}
                        >
                            Record toevoegen
                        </Button>
                    }
                >
                    <Suspense
                        fallback={
                            <Loader />
                        }
                    >
                        <DropdownItem onClick={() => navigate('/vacatures/toevoegen')}>Vacature</DropdownItem>
                        <DropdownItem onClick={() => navigate('/kandidaten/toevoegen')}>Kandidaat</DropdownItem>
                        <DropdownItem onClick={() => navigate('/bedrijven/toevoegen')}>Bedrijf</DropdownItem>
                        <DropdownItem onClick={() => navigate('/contactpersonen/toevoegen')}>Contactpersoon</DropdownItem>
                        <DropdownItem onClick={() => navigate('/aanbiedingen/toevoegen')}>Aanbieding</DropdownItem>
                    </Suspense>
                </Dropdown>

                <GlobalSearch />
            </div>
        </div>
        
        { children }
    </div>;
}

interface Props {
    children?: any
    breadcrumbs?: any
    padding?: 'bottomless' | 'normal'
    position?: 'static' | 'sticky'
}

export default PageHeader;